// Write relay-ai-launch.config.toml for Codex — never touch ~/.codex/config.toml.
import { join } from 'node:path';
import { codexProviderEnvKey, type CodexRoute } from './routing.js';
import { CODEX_PROFILE_NAME, getCatalogPath, getCodexProfilePath, getRelayAiCodexDir } from './session.js';

export interface CodexProfileSpec {
  route: CodexRoute;
  proxyPort?: number;
  catalogPath: string;
  /** When set, seeds Codex reasoning picker for capable models. */
  modelReasoningEffort?: string;
}

/** Full network + filesystem access for shell tools (nlm, curl, npm, MCP CLIs). */
export const CODEX_LAUNCH_SANDBOX = 'danger-full-access';

function profileReasoningLine(effort?: string): string {
  return effort ? `model_reasoning_effort = ${tomlString(effort)}\n` : '';
}

function profileSandboxLine(): string {
  return `sandbox = ${tomlString(CODEX_LAUNCH_SANDBOX)}\n`;
}

function tomlString(value: string): string {
  return JSON.stringify(value);
}

export function buildCodexProfileToml(spec: CodexProfileSpec): string {
  const { route, proxyPort, catalogPath, modelReasoningEffort } = spec;
  const model = route.modelId;
  const reasoning = profileReasoningLine(modelReasoningEffort);

  if (route.tier === 'direct') {
    const envKey = codexProviderEnvKey(route.providerId);
    const baseUrl = route.baseURL ?? 'https://api.openai.com/v1';
    return `# Generated by relay-ai — do not edit
${profileSandboxLine()}model = ${tomlString(model)}
model_provider = ${tomlString(route.providerId)}
model_catalog_json = ${tomlString(catalogPath)}
${reasoning}
[model_providers.${route.providerId}]
name = ${tomlString(route.providerId)}
base_url = ${tomlString(baseUrl)}
env_key = ${tomlString(envKey)}
wire_api = "responses"
`;
  }

  const proxyBase = `http://127.0.0.1:${proxyPort}/v1`;
  return `# Generated by relay-ai — do not edit
${profileSandboxLine()}model = ${tomlString(model)}
model_provider = "relay-ai-proxy"
model_catalog_json = ${tomlString(catalogPath)}
${reasoning}
[model_providers.relay-ai-proxy]
name = "relay-ai"
base_url = ${tomlString(proxyBase)}
env_key = "RELAY_AI_CODEX_KEY"
wire_api = "responses"
`;
}

export function getProfileOutputPath(): string {
  return getCodexProfilePath();
}

export function getCatalogOutputPath(providerId: string): string {
  return getCatalogPath(providerId);
}

export function getFavoritesCatalogPath(): string {
  return join(getRelayAiCodexDir(), 'models-favorites.json');
}

export function getFavoritesAppCatalogPath(): string {
  return join(getRelayAiCodexDir(), 'app-models-favorites.json');
}

export function profileName(): string {
  return CODEX_PROFILE_NAME;
}
